module.exports = __webpack_public_path__ + "static/media/intersect.13fbcae7.svg";